import React from 'react';
import clsx from 'clsx';
import { Button, Icon, Inline, Text } from '@treatwell/ui';
import { ConditionalWrapper } from 'js/components/Utilities/ConditionalWrapper';
import { Filter } from '../../Filters/useFilters';
import styles from './FiltersButton.module.css';

type OptionalArgs<T, K extends keyof T> = Partial<Pick<T, K>> & Omit<T, K>;

export const FiltersButton = ({
  chipLabel: label,
  isActive,
  count,
  icon,
  buttonStyle = 'Default',
  dataCy,
  onClick,
  ref,
}: OptionalArgs<Omit<Filter, 'title'>, 'id' | 'isActive'> & {
  icon?: Icon;
  buttonStyle?: 'Default' | 'Red';
  dataCy?: string;
  onClick: () => void;
  ref?: React.Ref<HTMLButtonElement>;
}) => (
  <Button
    className={clsx(styles.button, styles[`button${buttonStyle}`], {
      [styles.active]: isActive,
    })}
    onClick={onClick}
    data-cy={dataCy}
    ref={ref}
  >
    <ConditionalWrapper
      condition={icon !== undefined || count !== undefined}
      render={(children) => <Inline space="xs">{children}</Inline>}
    >
      {icon ?? null}

      <Text type="caption">{label}</Text>

      {count ? (
        <Text className={styles.count} type="footnoteHeavy">
          {count}
        </Text>
      ) : null}
    </ConditionalWrapper>
  </Button>
);
